import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  get<T>(key: string): T | void {
    try {
      return JSON.parse(localStorage.getItem(key)!) as T;
    } catch (error) {
      console.error(error);
    }
  }

  set(key: string, data: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {}
  }
  delete(key: string): void {
    localStorage.removeItem(key);
  }
}
